import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { useAuth } from "../../context/AuthContext";
import ProductCard from "../../components/store/ProductCard";

export default function Wishlist() {
  const { wishlist } = useCart();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="px-6 py-24 text-center" data-testid="wishlist-signed-out">
        <h1 className="font-display text-4xl">Sign in to view your wishlist</h1>
      </div>
    );
  }

  return (
    <div className="px-6 md:px-12 lg:px-24 py-10" data-testid="wishlist-page">
      <div className="overline mb-2">Saved</div>
      <h1 className="font-display text-4xl lg:text-5xl mb-10">Your Wishlist</h1>
      {(!wishlist.products || wishlist.products.length === 0) ? (
        <div className="text-center py-16">
          <p className="text-[hsl(var(--kb-muted))] mb-6">Nothing saved yet.</p>
          <Link to="/shop" className="kb-btn-primary inline-block">Explore pieces</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {wishlist.products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
